<script setup>
// 비전 배경 곡선 4개.
//
// 비전 섹션 안에 있던 장식이다(Figma 391:286 / 290 / 293 / 294). 2026-09-26 에
// 배경과 콘텐츠를 나누면서 여기로 옮겼다. 섹션 안에 있는 동안은
//   - 콘텐츠 상자에 잘려서, 섹션 높이를 건드릴 때마다 잘리는 자리가 달라졌고
//   - 구조 층과 배율이 달라(bgK vs k) 카드와 따로 놀았다
// 유튜브 워터마크와 같은 문제라 같은 자리로 보낸다.
//
// 원본은 1920x1116 캔버스에 그려졌고 아래끝이 섹션 아래끝과 맞는다. 그래서 여기서도
// 아래를 기준으로 놓고, 화면 폭에 맞춰 통째로 줄인다. 아무것과도 맞물리지 않는
// 장식이라 비율만 지키면 된다.
import { computed } from 'vue'
import imgGroup2147228500 from '@/assets/figma/1ccc2df3654d8eef348e0c13e1ca3b35e0ac52ea.svg'
import imgGroup2147228492 from '@/assets/figma/73c1fe7c3af6d6f654f57bbdb7a11eaa7c0dbaab.svg'
import imgVector22 from '@/assets/figma/96bc7686dafb05e593bbaae3715f8f4b769ce850.svg'
import imgEllipse32 from '@/assets/figma/c63b0ee98b4bc1a4337586d2c97706c4ba033678.svg'

const DESIGN_W = 1920
const DESIGN_H = 1116

const props = defineProps({
  // 배경 층의 폭. SceneBackdrop 이 재서 넘겨준다.
  width: { type: Number, default: 0 },
  // 배율을 바깥에서 직접 줄 때 쓴다(2026-10-16). 비전 섹션이 제 구조 층
  // 좌표계(1920x1116)에 이 곡선을 얹으면서 생겼다 - 그때는 바깥 상자가 이미
  // 줄여 놓았으므로 여기서는 1 이어야 한다. null 이면 예전처럼 폭에서 구한다.
  scale: { type: Number, default: null },
})

const scale = computed(() =>
  props.scale != null ? props.scale : props.width ? props.width / DESIGN_W : 1,
)
</script>

<template>
  <div
    class="pointer-events-none absolute bottom-0 left-1/2 origin-bottom"
    :style="{
      width: `${DESIGN_W}px`,
      height: `${DESIGN_H}px`,
      transform: `translateX(-50%) scale(${scale})`,
    }"
  >
    <div class="absolute h-[1545.916px] left-[-59px] top-[-48.62px] w-[1984.5px]" data-node-id="391:286">
      <img alt="" class="absolute block inset-0 max-w-none size-full" :src="imgGroup2147228500" />
    </div>
    <div class="absolute flex h-[892.967px] items-center justify-center left-[-195px] top-[548.42px] w-[2243.612px]" data-node-id="391:290">
      <div class="flex-none rotate-[-15.73deg]">
        <div class="h-[294.424px] relative w-[2248px]">
          <div class="absolute inset-[-35.66%_-4%_-35.65%_-4.18%]">
            <img alt="" class="block max-w-none size-full" :src="imgGroup2147228492" />
          </div>
        </div>
      </div>
    </div>
    <div class="absolute flex h-[615.976px] items-center justify-center left-[31.31px] top-[625.58px] w-[1824.842px]" data-node-id="391:293">
      <div class="flex-none rotate-[-18.65deg]">
        <div class="h-0 relative w-[1926px]">
          <div class="absolute inset-[-0.5px_0]">
            <img alt="" class="block max-w-none size-full" :src="imgVector22" />
          </div>
        </div>
      </div>
    </div>
    <div class="-translate-x-1/2 absolute bottom-[-508px] h-[502px] left-[calc(50%+0.5px)] w-[2297px]" data-node-id="391:294">
      <div class="absolute inset-[-59.76%_-13.06%]">
        <img alt="" class="block max-w-none size-full" :src="imgEllipse32" />
      </div>
    </div>
  </div>
</template>
